import React from 'react';

interface TreadwellTireRegularIconProps {
  className?: string;
  styleName?: string;
}

function TreadwellTireRegularIcon(props: TreadwellTireRegularIconProps) {
  const { className } = props;

  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.892 11.568c-2.604 0-4.715-2.111-4.715-4.715s2.111-4.715 4.715-4.715 4.715 2.111 4.715 4.715-2.111 4.715-4.715 4.715h0zm-4.874-.626l-.042-.073.113.133-.071-.06zM.53 6.878l.013-.076-.001.046.003.112-.014-.082zm12.984 1.918l.27-1.595-.508-.371.505-.375-.282-1.593-.622-.184-.009-.025.356-.542-.813-1.399-.628.039.148-.611-1.236-1.044-.599.257-.029-.016-.075-.648L8.473.136l-.475.45H8L7.994.585 7.701 0H6.083l-.292.585h.018l-.075.014.017-.006-.477-.447-1.518.561-.072.65.035-.013-.065.038.026-.022-.601-.257-1.234 1.046.155.635.046-.039-.093.112.03-.052-.653-.034-.798 1.408.365.543.03-.054-.042.126.012-.072-.626.191L0 6.507l.508.371-.505.375.282 1.593.627.186-.017-.093.071.194-.048-.082-.359.547.813 1.399.628-.039-.148.611 1.236 1.044.601-.258-.068-.057.181.104-.087-.031.075.649 1.521.553.475-.45-.078-.028.162.029h-.08l.292.585h1.618l.292-.585h-.064l.165-.03-.06.022.477.447 1.518-.561.072-.65-.044.016.082-.047-.033.028.601.257 1.234-1.046-.155-.635-.022.019.051-.059-.011.019.653.034.798-1.408-.365-.543h0v-.001l.625-.191z"
          fill="#0b0c0c"
        />
        <path
          d="M2.435 6.854a4.46 4.46 0 0 1 4.458-4.458 4.46 4.46 0 0 1 4.458 4.458 4.46 4.46 0 0 1-4.458 4.458 4.46 4.46 0 0 1-4.458-4.458z"
          stroke="#fefefe"
          strokeWidth="1.709"
        />
        <path
          d="M2.761 6.854a4.13 4.13 0 1 1 8.262 0 4.13 4.13 0 1 1-8.262 0"
          fill="#eb2227"
        />
        <g fill="#fefefe">
          <path d="M3.519 10.498c0-.45.365-.815.815-.815s.815.365.815.815-.365.815-.815.815-.815-.365-.815-.815m4.777-7.485c0-.45.365-.815.815-.815s.815.365.815.815-.365.815-.815.815-.815-.365-.815-.815" />
          <use xlinkHref="#B" />
        </g>
        <use stroke="#fefefe" strokeWidth=".342" xlinkHref="#B" />
        <use fill="#fefefe" xlinkHref="#C" />
        <use stroke="#fefefe" strokeWidth=".342" xlinkHref="#C" />
      </g>
      <defs>
        <path
          d="M6.686 5.282H5.653c-.083 0-.131.036-.131.131v.279h-.38v-.439c0-.256.083-.338.339-.338h2.827c.255 0 .338.083.338.338v.439H8.26v-.279c0-.095-.041-.131-.13-.131H7.102v3.806h-.416V5.282z"
          id="B"
        />
        <path
          d="M6.784 8.991h.221V5.185h1.124c.145 0 .228.083.228.228v.181h.192v-.342c0-.2-.041-.241-.241-.241H5.481c-.201 0-.241.041-.241.241v.342h.185v-.181c0-.143.085-.228.228-.228h1.131v3.806zm.416.195h-.61V5.38h-.936c-.02 0-.029.003-.031.004s-.003.009-.003.03v.376h-.575v-.536c0-.309.126-.436.436-.436h2.827c.309 0 .435.126.435.436v.536h-.581v-.376c0-.019-.002-.028-.004-.032s-.011-.001-.03-.002h-.93v3.806z"
          id="C"
        />
      </defs>
    </svg>
  );
}

export default TreadwellTireRegularIcon;
